import { NavLink } from 'react-router';
import { FulfillmentNav } from './FulfillmentNav';
import { NavIcon } from './NavIcon';
import { navItem } from './navItem';
import { ObjectNavList } from './ObjectNavList';
import { PageHeader } from './PageHeader';

/**
 * THE DATA TAB IS A SCREEN, NOT A SHEET (round 3, finding A5; spec/anatomy/IOS.md, tab
 * bars: "every tab is the root of its own navigation stack").
 *
 * Round 1 gave the Data tab a bottom sheet over whatever screen was open, which is the
 * one construction a tab bar may not have: a sheet is modal, it belongs to the screen it
 * covers, and it cannot be the root of a stack - so pushing a record from it either
 * dismissed the sheet or left the person inside a modal with a record behind it. The tab
 * is a root screen now: its own large title, the object list the sidebar shows in the
 * same groups the sidebar groups it into, and a record pushes on top of it like any other
 * pushed screen.
 *
 * THE LIST IS THE SAME COMPONENT the sidebar uses, deliberately: the groups, their order
 * and the tiles come from the metadata, so this screen cannot drift from the sidebar.
 * `ObjectNavList` already chooses the phone's 28px tile below the desktop breakpoint.
 *
 * The sheet construction stays for More, which is not a stack root but a shelf of panes.
 */
export function DataPage() {
  return (
    <div className="pb-6">
      <PageHeader title="Data" />
      {/*
        NO SECOND "Objects" LANDMARK. The sidebar's navigation already carries that name,
        and at desktop width this route would put two of them on one page. The screen's own
        h1 says what this list is.
      */}
      <div>
        {/* The phone's form of the sidebar carries Ben's section first (fulfillment P2 item 1). */}
        <FulfillmentNav />
        <ObjectNavList />
        <NavLink to="/reports" className={navItem}>
          {/* The same component as the rows above it, so the same tile at the same size. */}
          <NavIcon icon="reports" />
          <span className="flex-1 truncate">Reports</span>
        </NavLink>
      </div>
    </div>
  );
}
